<template lang="pug">
v-card(flat)
  v-card-title.text-body-1 Подтверждение почты
  v-card-text
    span(v-if="!verifySended") Письмо будет отправленно на почту
    span(v-else) Письмо отправленно на
    span: strong  "{{ $user.data.email }}"
  v-card-actions
    v-btn(
      block color="success" @click="startTimer" :disabled="!!timer"
    ) {{ timer ? `отправить повторно через ${seconds}` : 'Отправить'}}
    //- v-btn(
    //-   block text small
    //- ) Сменить адрес
</template>
<script>
export default {
  data() {
    return {
      seconds: 60,
      timer: null,
      verifySended: false,
    };
  },
  methods: {
    startTimer() {
      this.verifySended = true;
      this.$api.auth.sendVerify();
      this.timer = setInterval(this.setCurrentTime, 1000);
    },
    setCurrentTime() {
      this.seconds -= 1;
      if (this.seconds === 0) {
        clearInterval(this.timer);
        this.timer = null;
        this.seconds = 60;
      }
    },
  },
};
</script>
